/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { NavLink } from "react-router-dom";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Hidden from "@material-ui/core/Hidden";
import Collapse from "@material-ui/core/Collapse";
import Icon from "@material-ui/core/Icon";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";

// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";
import SidebarCart from "container/view/SidebarCartContainer.js";

import sidebarStyle from "assets/jss/material-dashboard-pro-react/components/sidebarStyle.js";

import {
  warningColor,
  hexToRgb,
} from "assets/jss/material-dashboard-pro-react.js";
import avatar from "assets/img/faces/avatar.jpg";

var ps;

// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
class SidebarWrapper extends React.Component {
  sidebarWrapper = React.createRef();
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.sidebarWrapper.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  render() {
    const { className, user, headerLinks, cart } = this.props;
    return (
      <div className={className} ref={this.sidebarWrapper}>
        {user}
        {headerLinks}
        {cart}
      </div>
    );
  }
}

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      miniActive: true,
    };
  }
  mainPanel = React.createRef();

  render() {
    const {
      classes,
      logo,
      webLink,
      image,
      logoText,
      routes,
      bgColor,
      rtlActive,
      cartCounter,
      customStyle,
      showCartSideBar = false,
      closeCartSideBar = () => {},
    } = this.props;

    let cart = <SidebarCart closeCartSideBar={closeCartSideBar} />;

    const logoMini =
      classes.logoMini +
      " " +
      cx({
        [classes.logoMiniRTL]: rtlActive,
      });
    const logoClasses =
      classes.logo +
      " " +
      cx({
        [classes.whiteAfter]: bgColor === "white",
      });

    let brand = (
      <a href={webLink} target="_blank" className={logoClasses}>
        <div className={logoMini}>
          {logo ? <img src={logo} alt="logo" className={classes.img} /> : null}
        </div>
        {/* <div
          // GO TO BUSINESS RESTAURANT

          className={logoNormal}
          style={{ whiteSpace: 'normal', lineHeight: 'normal', color: 'rgba(74,74,74,1)'}}
        >
          {logoText}
        </div> */}
      </a>
    );
    const drawerPaper =
      classes.drawerPaper +
      " " +
      cx({
        [classes.drawerPaperMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.drawerPaperRTL]: rtlActive,
      });
    const sidebarWrapper =
      classes.sidebarWrapper +
      " " +
      cx({
        [classes.drawerPaperMini]:
          this.props.miniActive && this.state.miniActive,
        [classes.sidebarWrapperWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1,
      });

    return (
      <div ref={this.mainPanel}>
        <Hidden smDown implementation="css">
          {/* ******* WEB >= 960******* */}
          <Drawer
            onMouseOver={() => this.setState({ miniActive: false })}
            onMouseOut={() => this.setState({ miniActive: true })}
            anchor={rtlActive ? "right" : "left"}
            open={showCartSideBar}
            classes={{
              paper: drawerPaper + " " + classes[bgColor + "Background"],
            }}
            onClose={closeCartSideBar}
          >
            {/*brand*/}
            <SidebarWrapper
              className={sidebarWrapper}
              cart={
                this.props.miniActive && this.state.miniActive ? (
                  <div
                    style={{
                      fontFamily: "'Archivo Narrow', sans-serif",
                      margin: "2px 5px",
                      width: "initial",
                    }}
                  >
                    {cartCounter && cartCounter > 0 ? (
                      // <span className={'notifications'}>{cartCounter}</span>
                      <span
                        className={classes.notifications}
                        style={{ top: "16px", left: "42px" }}
                      >
                        {cartCounter}
                      </span>
                    ) : null}

                    <ShoppingBasketIcon
                      style={{
                        margin: "20px",
                        fontSize: "30px",
                        color:
                          "rgba(" +
                          hexToRgb(customStyle.buttonCart || warningColor[0]) +
                          ", 0.7)",
                      }}
                    />
                  </div>
                ) : (
                  cart
                )
              }
            />
            {image !== undefined ? (
              <div
                className={classes.background}
                style={{ backgroundImage: "url(" + image + ")" }}
              />
            ) : null}
          </Drawer>
        </Hidden>
      </div>
    );
  }
}

Sidebar.defaultProps = {
  bgColor: "blue",
};

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  bgColor: PropTypes.oneOf(["white", "black", "blue"]),
  rtlActive: PropTypes.bool,
  color: PropTypes.oneOf([
    "white",
    "red",
    "orange",
    "green",
    "blue",
    "purple",
    "rose",
  ]),
  logo: PropTypes.string,
  logoText: PropTypes.string,
  webLink: PropTypes.string,
  image: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  miniActive: PropTypes.bool,
  open: PropTypes.bool,

  // CUSTOM
  t: PropTypes.func.isRequired,
  cartCounter: PropTypes.number.isRequired,
  customStyle: PropTypes.object,
};

SidebarWrapper.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object,
  headerLinks: PropTypes.object,
  links: PropTypes.object,
};

export default withStyles(sidebarStyle)(Sidebar);
